/* SpiriLounge theme layer: reveal, countdown, "#buy" links and, on the new product page only, the Kaching wording */
(function(){
  if(window.__slInit)return;window.__slInit=true;
  function pad(n){return (n<10?'0':'')+n}
  function tick(){
    var now=new Date(),end=new Date(now);end.setHours(24,0,0,0);
    var t=Math.max(0,Math.floor((end-now)/1000));
    [].forEach.call(document.querySelectorAll('[data-sl-cd]'),function(c){
      var h=c.querySelector('[data-h]'),m=c.querySelector('[data-m]'),s=c.querySelector('[data-s]');
      if(h)h.textContent=pad(Math.floor(t/3600));if(m)m.textContent=pad(Math.floor(t%3600/60));if(s)s.textContent=pad(t%60);
    });
  }
  function buyTarget(){return document.querySelector('kaching-bundles-block')||document.querySelector('.product-form__buttons')||document.querySelector('product-form')||document.querySelector('.product__info-container')}

  var BARS=[
    {t:'1 Pyramid',s:'Start with your bedroom tonight',u:1},
    {t:'Buy 2, Get 1 Free',s:'3 Pyramids · your main rooms',l:'Recommended',u:3},
    {t:'Buy 3, Get 2 Free',s:'5 Pyramids · home and family',l:'Best value',u:5}
  ];
  function setTxt(el,txt){ if(!el)return; for(var i=0;i<el.childNodes.length;i++){ var n=el.childNodes[i]; if(n.nodeType===3){ if(n.nodeValue!==txt)n.nodeValue=txt; return; } } }
  function perUnit(str,u){
    var m=str.match(/[\d.,]+/); if(!m)return '';
    var raw=m[0], comma=/,\d{2}$/.test(raw);
    var num=parseFloat(comma?raw.replace(/\./g,'').replace(',','.'):raw.replace(/,/g,'')); if(!num)return '';
    var v=num/u, dec=/[.,]\d{2}$/.test(raw)||Math.round(v*100)%100!==0;
    var s=dec?v.toFixed(2):String(Math.round(v)); if(comma)s=s.replace('.',',');
    return str.replace(raw,s)+' each';
  }
  function kaching(){
    var blk=document.querySelector('kaching-bundles-block'); if(!blk)return;
    setTxt(blk.querySelector('.kaching-bundles__block-title'),'Choose your protection');
    var bars=blk.querySelectorAll('.kaching-bundles__bar');
    [].forEach.call(bars,function(b,i){
      var m=BARS[i]; if(!m)return;
      if(b.getAttribute('data-sl-i')!==String(i))b.setAttribute('data-sl-i',i);
      setTxt(b.querySelector('.kaching-bundles__bar-title'),m.t);
      setTxt(b.querySelector('.kaching-bundles__bar-subtitle'),m.s);
      if(m.l)setTxt(b.querySelector('.kaching-bundles__bar-label'),m.l);
      var pr=b.querySelector('.kaching-bundles__bar-pricing'),p=b.querySelector('.kaching-bundles__bar-price');
      if(pr&&p&&m.u>1){ var e=perUnit((p.textContent||'').trim(),m.u); if(e&&pr.getAttribute('data-sl-each')!==e)pr.setAttribute('data-sl-each',e); }
    });
  }
  /* Kaching can load late (some apps wait for user activity) and can redraw its block, so watch the page with no time limit */
  function watchKaching(){
    var busy=false;
    kaching();
    new MutationObserver(function(){
      if(busy)return; busy=true;
      setTimeout(function(){ kaching(); busy=false; },40);
    }).observe(document.body,{subtree:true,childList:true,characterData:true});
  }

  function init(){
    if(document.querySelector('[data-sl-cd]')){tick();setInterval(tick,1000);}
    if(document.body.classList.contains('sl-pdp-v2'))watchKaching();
    [].forEach.call(document.querySelectorAll('a[href="#buy"]'),function(a){
      a.addEventListener('click',function(e){var t=buyTarget();if(!t)return;e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'center'})});
    });
    var els=[].slice.call(document.querySelectorAll('.sl-reveal'));
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(x){if(x.isIntersecting){x.target.classList.add('sl-in');io.unobserve(x.target)}})},{threshold:.12});
      els.forEach(function(el){io.observe(el)});
    } else {els.forEach(function(el){el.classList.add('sl-in')})}
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
})();
